import {
	Validator
} from 'vee-validate'
import {
	BasicSelect
} from 'vue-search-select'
import CONSTANT from './../../../../../shared/constants/constant';
import MasterService from './../../../../services/masterdata.service';
import CryptoJS from 'crypto-js';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';


export default {
	name: 'otherinformation',
	components: {
		BasicSelect,
		Treeselect
	},
	props: ['callFrom'],
	data() {
		return {
			isSaved:false,
			insuranceChargeType: null,
			fovChargePerShipment: null,
			rateTemplateId: null,
			fovType: null,
			fovRate: '',
			chooseSlab: '',
			slabList: [],
			selectedSlab: {
				label: null,
				id: null
			},
			slabtype: '',
			selectedSlabListArray: [],
			minfovchargelimit: null,
			maxfovchargelimit: null,
			SYMBOL_CONFIG: {
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN_EQUAL_TO]: "<=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN_EQUAL_TO]: ">=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN]: "<",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN]: ">"
			},
			type: null,
			insuranceapplicablecharge:null,
			insurancechargetypeflag:0
		}
	},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userName = userdetail.email;
		this.getSlabList();
	},
	methods: {
		isNumber: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		  },
		setValues(data, isMasterRate) {
			try {
				if (data.id) {
					this.insuranceChargeType = data.insurancechargetype && (data.insurancechargetype == 1 ? 'FOV_CHARGE' : 'FLAT_CHARGE');
					this.fovType = data.fovtype && (data.fovtype == 1 ? 'FLAT' : '');
					if(!this.fovType){
					this.fovType = data.fovtype && (data.fovtype == 2 ? 'SLAB' : '');
					}
					if(data.insuranceapplicablecharge==0){
						this.insuranceapplicablecharge="None";
					}
					if(data.insuranceapplicablecharge==1){
						this.insuranceapplicablecharge="FOV";
					}
					if(data.insuranceapplicablecharge==2){
						this.insuranceapplicablecharge="ROV";
					}
					this.rateTemplateId = data.id

					this.getInsuranceRateDetails(data.id, isMasterRate);
				}
			} catch (err) {
				console.log(err)
			}
		},
		async getInsuranceRateDetails(id, isMasterRate) {
			try {
				let payload = {}
				this.isLoading = true;
				let response;
				if(!this.isSaved && (!this.callFrom || isMasterRate)){
					payload.ratetemplateid = id;
					response = await MasterService.getInsuranceRateList(payload);
				} else if(this.callFrom && this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE){
					payload.ratetemplateid = this.callFrom.id;
					response = await MasterService.getContractInsuranceRateList(payload);
				} else if(this.callFrom && this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE){
					payload.ratetemplateid = this.callFrom.id;
					response = await MasterService.getClientContractInsuranceRateList(payload);
				}
				this.selectedSlabListArray = [];
				this.isLoading = false;
				if (response.data.data[0] && response.data.data[0].insurancechargetype == 1) {
					if (response.data.data[0] && response.data.data[0].slabid) {
						this.selectedSlab.id = response.data.data[0].slabid;
						this.insuranceChargeType = 'FOV_CHARGE';
						response.data.data.forEach((el) => {
							this.selectedSlabListArray.push({
								from: `${el.fromvalue}`,
								to: `${el.tovalue}`,
								fovpercentage: el.fovvalue,
								slabsequence: el.slabsequence,
								insurancerateid: el.id
							});
						});

						this.selectedSlab.label = this.slabList.find(o => o.id == response.data.data[0].slabid).label
						//this.selectedSlab.id = this.slabList.find(o => o.value == response.data.data[0].slabid).value

					} else {
						this.fovRate = response.data.data[0].fovvalue
					}
					this.minfovchargelimit = response.data.data[0].minfovvalue;
					this.maxfovchargelimit = response.data.data[0].maxfovvalue;
				} else if (response.data.data[0]) {
					if (response.data.data[0].insurancechargetype == 2) {
						this.insuranceChargeType = 'FLAT_CHARGE';
					}
					this.fovChargePerShipment = response.data.data[0].fovvalue;
					// this.fovtype = this.fovType;
				} else {
					console.log("no record found");
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		async setValuesAfterId(data) {
			try {
				if (data.id) {
					this.rateTemplateId = data.id
					let baseRateObject = this.getInsuranceRateObject();
					let response;
					if(!this.callFrom){
					response = await MasterService.saveInsuranceRate(baseRateObject);
					} else if(this.callFrom && this.callFrom.name==CONSTANT.CONTRACT_TEMPLATE){
						delete baseRateObject.ratetemplateid;
						baseRateObject.contractid = this.callFrom.contractid;
						baseRateObject.contractservicesid = this.callFrom.contractservicesid;
						baseRateObject.ratetemplateid = this.callFrom.id
						response = await MasterService.saveContractMasterInsuranceRate(baseRateObject)
					} else if(this.callFrom && this.callFrom.name==CONSTANT.CLIENT_CONTRACT_TEMPLATE){
						delete baseRateObject.ratetemplateid;
						baseRateObject.contractid = this.callFrom.contractid;
						baseRateObject.contractservicesid = this.callFrom.contractservicesid;
						baseRateObject.ratetemplateid = this.callFrom.id;
						response = await MasterService.saveClientContractMasterInsuranceRate(baseRateObject)
					}
					if (response.data.code == 200) {
						if (this.type == "saveAndNext") {
							this.$emit("goToNextStepOrListing", 'next')
						} else {
							this.$emit("goToNextStepOrListing", 'list')
						}
						if (this.callFrom && (this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE || this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE)) {
							this.isSaved= true
						}
					} else {
						this.$alert(result.data.message, data.name, "error");
					}
				}
			} catch (err) {
				console.log(err)
			}
		},
		selectedType(type) {
			this.insurancechargetypeflag = 0;
			if (type != 'FLAT_CHARGE') {
				this.fovType = null;
			}
		},
		clearValidation(){
			this.insurancechargetypeflag = 0;
		},
		saveOnTabChange(){
			this.saveInsuranceCharges("saveAndNext", true)
		},
		saveInsuranceCharges(type, isTabChange) {
			this.$validator.validateAll().then((result) => {
				if (this.insuranceChargeType == 0 && this.insuranceapplicablecharge!= "None") {
					this.insurancechargetypeflag = 1;
				}
				if (result && (this.insuranceChargeType != 0 || this.insuranceapplicablecharge == "None")) {
					let submitobject = {
						insurancechargetype: CONSTANT.INSURANCE_CHARGE_TYPE[this.insuranceChargeType],
						fovtype: CONSTANT.FOV_TYPE[this.fovType]
					}
					if(this.insuranceapplicablecharge=="None"){
						submitobject.insuranceapplicablecharge=0;
					}
					if(this.insuranceapplicablecharge=="FOV"){
						submitobject.insuranceapplicablecharge=1;
					}
					if(this.insuranceapplicablecharge=="ROV"){
						submitobject.insuranceapplicablecharge=2;
					}
					if(isTabChange) {
						submitobject.isTabChange = isTabChange;
					}
					this.$emit("createAndGetId", submitobject);
					this.type = type;
				}else{
					return false;
				}
			}).catch((err) => {
				console.log('errors exist', err)
			});
		},

		getInsuranceRateObject() {
			let submitObj = {};
			submitObj.ratetemplateid = this.rateTemplateId;
			submitObj.insurancechargetype = CONSTANT.INSURANCE_CHARGE_TYPE[this.insuranceChargeType] || null;
			submitObj.lastmodifiedby = this.userName;
			submitObj.createdby = this.userName;
			if(this.insuranceapplicablecharge=="None"){
				submitObj.insuranceapplicablecharge=0;
			}
			if(this.insuranceapplicablecharge=="FOV"){
				submitObj.insuranceapplicablecharge=1;
			}
			if(this.insuranceapplicablecharge=="ROV"){
				submitObj.insuranceapplicablecharge=2;
			}
			if (submitObj.insurancechargetype == CONSTANT.INSURANCE_CHARGE_TYPE.FLAT_CHARGE) {
				submitObj.slabArray = [{
					insurancerateid: 0,
					fovvalue: this.fovChargePerShipment || null
				}]
				return submitObj;
			}
			submitObj.slabid = this.selectedSlab.id || null;
			submitObj.slabArray = [];
			if (this.fovType && CONSTANT.FOV_TYPE[this.fovType] == 2) {
				this.selectedSlabListArray.forEach((el) => {
					submitObj.slabArray.push({
						insurancerateid: el.insurancerateid || null,
						slabsequence: el.slabsequence,
						fromvalue: el.from,
						tovalue: el.to,
						fovvalue: el.fovpercentage || null,
					})
				})
			} else {
				submitObj.slabid = null;
				submitObj.slabArray = [{
					insurancerateid: 0,
					slabsequence: null,
					fromvalue: null,
					tovalue: null,
					fovvalue: this.fovRate || null,
				}]
			}
			submitObj.minfovvalue = this.minfovchargelimit || null;
			submitObj.maxfovvalue = this.maxfovchargelimit || null;
			submitObj.fovtype = this.fovType && CONSTANT.FOV_TYPE[this.fovType];
			return submitObj;



		},
		selectSlab(slab) {
			if(slab.id) {
				this.selectedSlab.id = slab.id;
				this.selectedSlab.label = slab.label;
				this.getSlabDetails(slab.id);
			}
		},
		async getSlabDetails(id) {
			try {
				this.selectedSlabListArray = [];
				let weightInputPayload = {
					slabid: id
				}
				this.isLoading = true;
				let response = await MasterService.getSlabDetails(weightInputPayload);
				this.isLoading = false;

				response.data.data.slabbreakupdetails.forEach((el) => {
					let fromname = '';
					if (this.SYMBOL_CONFIG[el.lowerlimit] == '>') {
						fromname = el.lowerlimitvalue + 1;
					} else {
						fromname = el.lowerlimitvalue;
					}

					let toname = '';
					if (this.SYMBOL_CONFIG[el.higherlimit] == '<') {
						toname = el.higherlimitvalue - 1;
					} else {
						toname = el.higherlimitvalue;
					}
					// let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue},${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`
					this.selectedSlabListArray.push({
						from: fromname,
						to: toname,
						fovpercentage: '',
						slabsequence: el.slabnumber
					});
				});
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		async getSlabList() {
			try {
				let invoiceInputPayload = {
					slabtype: CONSTANT.SLAB_TYPE.INVOICE_AMOUNT
				}
				this.isLoading = true;
				let result = await MasterService.getAllSlab(invoiceInputPayload);
				this.isLoading = false;
				result.data.data.forEach(element => {
					let isdisabled = false;
					if(element.status == 0){
						isdisabled=true;
					}
					this.slabList.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					});
				});
				// result[1].data.data.forEach(element => {
				// 	let isdisabled = false;
				// 	if(element.status == 0){
				// 		isdisabled=true;
				// 	}
				// 	this.slabList.push({
				// 		id: element.id,
				// 		label: element.slabname,
				// 		isDisabled:isdisabled
				// 	});
				// });
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},

		saveAndNext() {
			this.saveInsuranceCharges('saveAndNext')
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ratetemplate/createratetemplate/insurancecharges/insurancecharges.component.js